import { render } from "./CartDrawer.vue?vue&type=template&id=2870a0b2&scoped=true"
import script from "./CartDrawer.vue?vue&type=script&lang=js"
export * from "./CartDrawer.vue?vue&type=script&lang=js"

import "./CartDrawer.vue?vue&type=style&index=0&id=2870a0b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2870a0b2"]])

export default __exports__